module.exports = __webpack_public_path__ + "static/media/georgiab.8a8c360b.woff";